import * as yup from "yup";

const REQUIRED_MESSAGE = "This field is required";

export const idCardSchema = yup.object({
  iqamaNumber: yup.string().required(REQUIRED_MESSAGE),
  operatorName: yup.string().required(REQUIRED_MESSAGE),
  companyName: yup.string().required(REQUIRED_MESSAGE),
  issueDate: yup.string().required(REQUIRED_MESSAGE),
  expiryDate: yup.string().required(REQUIRED_MESSAGE),
  trade: yup.string().required(REQUIRED_MESSAGE),
});